import * as React from "react";

export type TabbedControlItemKey = string;

export interface TabbedControlItem {
  key: TabbedControlItemKey;
  name: string;
  icon?: string;
}

export interface TabbedControlProps {
  selectedItem: TabbedControlItemKey;
  // ^ One item MUST be selected, this is its key.
  items: TabbedControlItem[];
  // ^ All the items to show.
  onChange(key: TabbedControlItemKey, props: TabbedControlProps): void;
  // ^ XXX: Why does the callback get the props?
}

const TabbedControl = (props: TabbedControlProps) => {
  const { selectedItem, items, onChange } = props;
  const className = "horizontal-list";

  const onClick = (item: TabbedControlItem) => (): void => {
    if (item.key !== selectedItem) {
      onChange(item.key, props);
    }
  };

  const onTouchStart =
    (item: TabbedControlItem) =>
    (e: React.TouchEvent<any>): void => {
      e.preventDefault();
      onClick(item)();
    };

  const itemClassName = (key: TabbedControlItemKey): string =>
    className + "__item" + " " + className + "__item__" + key + (key === selectedItem ? " is-active" : "");

  return (
    <div className={`${className} horizontal-list--interactive`}>
      {items.map((item) => (
        <div
          key={item.key}
          className={itemClassName(item.key)}
          onClick={onClick(item)}
          onTouchStart={onTouchStart(item)}
        >
          {item.icon != null ? (
            <div>
              <i className={`icon-${item.icon}`} />
              {" " + item.name}
            </div>
          ) : (
            item.name
          )}
        </div>
      ))}
    </div>
  );
};

export default TabbedControl;
